import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIBadge(theme: Theme): Components['MuiBadge'] {
  return {
    defaultProps: {
      color: 'primary',
    },
    styleOverrides: {
      badge: {
        fontWeight: 400,
        fontSize: theme.typography.body2.fontSize,
      },
      standard: {
        minWidth: 18,
        height: 18,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      dot: {
        width: 10,
        height: 10,
        borderRadius: '50%',
      },
      colorNeutral: {
        color: theme.palette.shades[900],
        backgroundColor: theme.palette.shades[300],
      },
    },
  };
}
